import axios from 'axios';

const BaseAPI = axios.create({
  baseURL: process.env.REACT_APP_DEBITCREDIT,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { BaseAPI };
